module.exports = __webpack_public_path__ + "static/media/man_breaking_bird_home2.a94d7d7f.gif";